import { defineStore } from 'pinia'

import type { CPTType } from '@/stores/type/cpt.type'
import { useApi } from '@/api/useApi'
import { useBaseStore } from '@haskoning/vue-basestore'
import API from '@/api/apiUrls'

const api = useApi<CPTType>()

const baseUrl = API.CPT.BASE

export const useCPTStore = defineStore('cpt', () => {
	const baseStore = useBaseStore<CPTType>({ service: baseUrl, api })
	const fetchOrGetCPT = async (cptId: number): Promise<void> => {
		const cpt = baseStore.items.value.find((cpt: CPTType) => cpt.id === cptId)
		if (!cpt) {
			const response = await baseStore.fetchItem(cptId)
			if (response) {
				baseStore.addItems([response as CPTType])
				baseStore.setCurrentItem(response as CPTType)
			}
		} else {
			baseStore.setCurrentItem(cpt)
		}
	}
	return {
		...baseStore,
		fetchOrGetCPT
	}
})
